import React, { useRef, useState } from "react";
import "./Loved_By_Learners.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { Navigation, Autoplay } from "swiper/modules";

const Loved_By_Learners = () => {
  const swiperRef = useRef(null);

  const [activeIndex, setActiveIndex] = useState(0);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const [progress, setProgress] = useState(0);

  const testimonials = [
    {
      number: "4.6/5",
      text:
        "PST structured learning and mock interviews helped me gain confidence and secure multiple Data Engineering offers.",
      name: "Paresh Markad",
      logo: "/assets/images/home/loved_by_learners/img-1.png",
    },
    {
      rating: "★★★★★",
      text:
        "PST teaching and mentor support boosted my confidence in interviews. Their structured learning made my prep more effective.",
      name: "Aditya Jagtap",
      logo: "/assets/images/home/loved_by_learners/img-2.png",
    },
    {
      rating: "★★★★★",
      text:
        "PST structured learning and mock interviews helped me gain confidence and secure multiple Data Engineering offers.",
      name: "Paresh Markad",
      logo: "/assets/images/home/loved_by_learners/img-3.png",
    },
    {
      rating: "★★★★★ ",
      number: "4.6/5",
      text:
        "Great support and structured guidance throughout the program. Highly recommended!",
      name: "Aditya Jagtap",
      logo: "/assets/images/home/loved_by_learners/img-3.png",
    },
    {
      rating: "★★★★★",
      text:
        "PST structured learning and mock interviews helped me gain confidence and secure multiple Data Engineering offers.",
      name: "Paresh Markad",
      logo: "/assets/images/home/loved_by_learners/img-1.png",
    },
    {
      rating: "★★★★★",
      number: "4.6/5",
      text:
        "Great support and structured guidance throughout the program. Highly recommended!",
      name: "Aditya Jagtap",
      logo: "/assets/images/home/loved_by_learners/img-3.png",
    },
    {
      rating: "★★★★★",
      text:
        "PST structured learning and mock interviews helped me gain confidence and secure multiple Data Engineering offers.",
      name: "Paresh Markad",
      logo: "/assets/images/home/loved_by_learners/img-1.png",
    },
  ];

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev();
    }
  };

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext();
    }
  };

  return (
    <section className="Loved_By_Learners">
      <div className="container">
        <div className="Loved_By_Learners_header">
          <h5>
            Loved by <span>Learners</span>{" "}
          </h5>
          <img
            src="/assets/images/home/loved_by_learners/title-pic.png"
            alt="logo"
            className="header_img"
          />
        </div>

        <div className="testimonial_section">
          <div className="row align-items-center">
            <div className="col-lg-3 col-md-4">
              <div className="left_content">
                <div className="quote_holder">
                  <img
                    src="/assets/images/home/loved_by_learners/colon.png"
                    alt="quote"
                    className="quote_img"
                  />
                </div>

                <h5 className="quote_text">
                  Career outcomes that keep learners coming back.
                </h5>

                <div className="navigation_wrapper">
                  <button
                    className={`nav_btn ${isBeginning ? "disabled" : ""}`}
                    onClick={handlePrev}
                    disabled={isBeginning}
                  >
                    <FontAwesomeIcon icon={faArrowLeft} />
                  </button>

                  {/* Progress Line */}
                  <div className="progress_line">
                    <div
                      className="progress_fill"
                      style={{
                        width: `${progress * 100}%`,
                      }}
                    />
                  </div>

                  <button
                    className={`nav_btn ${isEnd ? "disabled" : ""}`}
                    onClick={handleNext}
                    disabled={isEnd}
                  >
                    <FontAwesomeIcon icon={faArrowRight} />
                  </button>
                </div>
              </div>
            </div>

            <div className="col-lg-9 col-md-8">
              <div className="testimonial_swiper_holder">
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={20}
                  slidesPerView={3}

                  /* ✅ AUTOPLAY SETTINGS */
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}

                  loop={true}   // 🔥 IMPORTANT for smooth infinite scroll

                  onSwiper={(swiper) => {
                    swiperRef.current = swiper;
                    setIsBeginning(swiper.isBeginning);
                    setIsEnd(swiper.isEnd);
                    setProgress(swiper.progress);
                  }}

                  onSlideChange={(swiper) => {
                    setActiveIndex(swiper.realIndex);
                    setIsBeginning(swiper.isBeginning);
                    setIsEnd(swiper.isEnd);
                    setProgress(swiper.progress);
                  }}

                  breakpoints={{
                    1200: { slidesPerView: 3 },
                    992: { slidesPerView: 2.2 },
                    768: { slidesPerView: 2 },
                    575: { slidesPerView: 2 },
                    320: { slidesPerView: 1.2 },
                    0: { slidesPerView: 1.2 },
                  }}
                >
                  {testimonials.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div className="testimonial_card">
                        <div className="platform_logo_holder">
                          <img
                            src={item.logo}
                            alt="logo"
                            className="platform_logo"
                          />
                        </div>

                        <div className="rating">
                          {item.rating}
                          <span className="item_number">
                            {item.number}
                          </span>
                        </div>

                        <p className="item_text">{item.text}</p>
                      </div>

                      <h6 className="item_name">{item.name}</h6>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Loved_By_Learners;